import {useTranslation} from 'react-i18next'

import {DataLinkIcon} from '../../assets'

export const DataLinkLogo = ({height, width}) => {
  const {t} = useTranslation()

  return <img src={DataLinkIcon} height={height} width={width} alt={t('header.logoImageLabel')} />
}
